module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-02empresariales-naves-industriales.27b47f6e.jpg";